{/* <p>
  <strong><%= t :subject %>:</strong>
  <%= @email.subject %>
</p>

<p>
  <strong><%= t :body %>:</strong>
  <%= @email.body.html_safe %>
</p>

<p>
  <strong><%= t :event %>:</strong>
  <%= I18n.t @email.lifecycle_event %>
</p>

<p style="margin-bottom:0">
  <strong><%= t :status %>:</strong>
  <%= I18n.t @email.status %>
</p> */}

import React from "react"
//import I18n from "i18n-js/index.js.erb"
import clsx from "clsx"

export default class EmailPresenterGeneral extends React.Component {
	constructor(props) {
		super(props)
  }

  componentDidMount() {
    return $("#email-body").append(this.props.email.body)
  }


  componentDidUpdate (prevProps) {
    // console.log("prevProps", prevProps, "Props", this.props)
    if(prevProps.email.body != this.props.email.body) {
      var translatedString = I18n.t('body')
      $("#email-body").empty()
      return $("#email-body").append(`<p id="email-body"><strong>${translatedString}: </strong>` + this.props.email.body + '</p>')
    }
  }


  addEmailBody () {


  }


	render() {
    // console.log("Props", this.props)
		var tabClasses = clsx({
			'active': this.props.active_tab == 'template',
			'tab-pane': true,
		})
		return (
			<div className={tabClasses} id="template">
        <p>
          <strong>{`${I18n.t('code')}: `}</strong>
          {this.props.email.code}
        </p>
        <p>
          <strong>{`${I18n.t('name')}: `}</strong>
          {this.props.email.name}
        </p>
        <p>
          <strong>{`${I18n.t('event')}: `}</strong>
          {I18n.t(this.props.email.lifecycle_event)}
        </p>
        <p>
          <strong>{`${I18n.t('status')}: `}</strong>
          {I18n.t(this.props.email.status)}
        </p>
        <div className="email-header">
          <div className="to-cc-bcc-subject">
            <div className="row">
              <div className="col-sm-12">
                <div className="input-group">
                  <div className="input-group-addon">{I18n.t('from')}</div>
                  <input autoComplete="nope" type="text" name="email[from_address]" className='form-control' defaultValue={this.props.email.from_address} readOnly={true} />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-sm-12">
                <div className="input-group">
                  <div className="input-group-addon">{I18n.t('to')}</div>
                  <input autoComplete="nope" type="text" name="email[to_addresses]" className='form-control' defaultValue={this.props.email.to_addresses} readOnly={true} />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-sm-6">
                <div className="input-group">
                  <div className="input-group-addon">{I18n.t('cc')}</div>
                  <input autoComplete="nope" type="text" name="email[cc_addresses]" className='form-control' defaultValue={this.props.email.cc_addresses} readOnly={true} />
                </div>
              </div>

              <div className="col-sm-6">
                <div className="input-group">
                  <div className="input-group-addon">{I18n.t('bcc')}</div>
                  <input autoComplete="nope" type="text" name="email[bcc_addresses]" className='form-control' defaultValue={this.props.email.bcc_addresses} readOnly={true} />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-sm-12">
                <div className="input-group">
                  <div className="input-group-addon">{I18n.t('subject')}</div>
                  <input autoComplete="nope" type="text" name="email[subject]" className='form-control' defaultValue={this.props.email.subject} data-name="subject" readOnly={true} />
                </div>
              </div>
            </div>
          </div>
        </div>
        <p id="email-body">
          {/* <strong>{`${I18n.t('body')}: `}</strong> */}
        </p>
			</div>
		);
	}
}
